import { Badge, Text } from '@change/ds-core-ui/next';

import copiedLinkIcon from 'src/assets/starterDashboardV2/readyToShare/copiedLinkIcon.svg';
import linkBioIcon from 'src/assets/starterDashboardV2/readyToShare/linkBioIcon.svg';
import linkStickerIcon from 'src/assets/starterDashboardV2/readyToShare/linkStickerIcon.png';
import pasteIcon from 'src/assets/starterDashboardV2/readyToShare/pasteIcon.svg';
import pasteUrlIcon from 'src/assets/starterDashboardV2/readyToShare/pasteUrlIcon.png';
import stickerIcon from 'src/assets/starterDashboardV2/readyToShare/stickerIcon.png';

import { thumbnailStyles } from './Step.styles';

export type StepVariant = 'sticker_icon' | 'copied_link' | 'paste' | 'paste_url' | 'link_in_bio' | 'link_sticker';

type Props = {
	stepLabel: string;
	label: string;
	variant: StepVariant;
};

const stepThumbnails: Record<StepVariant, string> = {
	copied_link: copiedLinkIcon,
	link_in_bio: linkBioIcon,
	link_sticker: linkStickerIcon,
	paste: pasteIcon,
	paste_url: pasteUrlIcon,
	sticker_icon: stickerIcon,
};

export function Step({ variant, stepLabel, label }: Props) {
	return (
		<div className="stroke-weaker rounded-large flex h-[88px] w-full flex-grow flex-row gap-4 overflow-hidden border">
			<div className="bg-background-overlay stroke-weaker flex h-full w-[72px] flex-shrink-0 items-center justify-center border-r">
				<img
					data-testid="step-thumbnail"
					src={stepThumbnails[variant]}
					alt={`Step thumbnail: ${stepLabel}`}
					className={thumbnailStyles({ variant })}
				/>
			</div>
			<div className="flex flex-grow flex-col items-start justify-center gap-2 pr-3">
				<Badge size="small" variant="information" label={stepLabel} />
				<Text className="text-size-body md:text-size-body-large">{label}</Text>
			</div>
		</div>
	);
}
